import { publicInstance } from 'api/axios';
import { usersV2 } from 'api/users/usersApi';
import { LoginResponseType } from 'api/users/login';

export interface passwordResetTokenPayloadType {
	passwordResetToken: string;
	email: string;
	newPassword: string;
}

function resetPassword(payload: passwordResetTokenPayloadType) {
	return publicInstance
		.patch<LoginResponseType>('password', payload, {
			baseURL: usersV2,
		})
		.then((res) => res.data);
}

export default resetPassword;
